import React from 'react';

// Hand-drawn underline used under one key word in page titles.
const Squiggle = () => (
  <svg className="dt-squiggle" viewBox="0 0 200 18" preserveAspectRatio="none" aria-hidden="true">
    <path d="M3 12 C 30 3, 52 16, 80 9 S 130 3, 158 10 S 190 12, 197 6" />
  </svg>
);

export default Squiggle;



// WEBPACK FOOTER //
// ./src/components/Squiggle.js